<template>
  <form
    name="blogRevisionsForm"
    @submit.prevent="updateActiveBlogItemVersion">
    <div
      class="page-tab-content-expand table blog-table revisions">
      <div class="thead">
        <div class="tr">
          <div class="th blog-version">
            Version
          </div>
          <div class="th blog-date">
            Date
          </div>
          <div class="th blog-title">
            Title
          </div>
          <div class="th blog-image">
            Image
          </div>
          <div class="th blog-content">
            Content
          </div>
        </div>
      </div>
      <div class="tbody">
        <div
          class="tr"
          :class="{
            'green lighten-4': revision.selected,
          }"
          v-for="revision in blogItemRevisions"
          :key="revision.version"
          @click="selectRevision(revision)">
          <div class="td blog-version">
            {{revision.version}}
          </div>
          <div class="td blog-date">
            {{revision.date | date}}
          </div>
          <div class="td blog-title text-truncate">
            {{revision.title}}
          </div>
          <div class="td blog-image">
            <img v-if="revision.imageContent" :src="revision.imageContent" />
            <small
              v-else
              class="font-italic text--secondary">
              not defined
            </small>
          </div>
          <div class="td blog-content">
            <div v-html="revision.content"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-buttons d-flex my-5">
      <v-btn
        type="submit"
        color="primary"
        :disabled="!selectedRevision">
        Revert to Selected Version
      </v-btn>

      <v-btn
        @click="goToContentList"
        type="button"
        color="primary"
        class="mr-auto order-first"
        outlined>
        Cancel
      </v-btn>
    </div>
  </form>
</template>

<script>
import BlogItemMixin from '../mixin.blog-item';

export default {
  name: 'BlogRevisions',
  mixins: [
    BlogItemMixin,
  ],
};
</script>

<style lang="scss">
</style>
